import {Checkbox, FormControlLabel, Tooltip, Typography} from '@mui/material';
import {memo} from 'react';
import {useTheme} from '@mui/material/styles';

const MhdRadioButton= ({ label, value, override, warning, error, onChange, disabled }) => {
  const theme = useTheme()
  return (
    <>
      <Tooltip
        title={warning} arrow
        componentsProps={{
          tooltip: {sx: {backgroundColor: theme.palette.error.main, color: 'white'}},
          arrow: {sx: {color: theme.palette.error.main}},
        }}
      >
      <FormControlLabel
        variant={error ? 'error' : 'primary'}
        label={label}
        labelPlacement='start'
        control={
          <Checkbox
            checked={override !== undefined ? !!override : !!value}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
          />
        }
      />
      </Tooltip>
      {(override !== undefined) &&
        <Typography variant='caption' color='error'>
          Modified: {!!override === true ? 'Set to True' : 'Set to False'}
        </Typography>
      }
    </>
  );
};

export default memo(MhdRadioButton);